import React from 'react';

interface SecondaryMetricCardProps {
  title: string;
  value: string | number;
  trend: string;
  isNegative?: boolean;
}

export function SecondaryMetricCard({ title, value, trend, isNegative }: SecondaryMetricCardProps) {
  const trendColor = isNegative ? '#e84c3d' : '#08d660';

  return (
    <div
      className="rounded-2xl p-4 backdrop-blur-sm border"
      style={{
        backgroundColor: '#111116',
        borderColor: '#1e1e25',
      }}
    >
      <div className="mb-3">
        <p style={{ color: '#8a8a95' }} className="text-xs font-medium mb-1">
          {title}
        </p>
        <h4 style={{ color: '#f5f5f7' }} className="text-2xl font-bold">
          {value}
        </h4>
      </div>

      <div style={{ color: trendColor }} className="text-xs font-medium">
        {trend}
      </div>
    </div>
  );
}
